import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M29.2 17l-.3.2c-1.4.8-4.1 1.4-6.4 1.4-2.3 0-5-.6-6.4-1.4l-.3-.2H6.4v11h9.5l.3-.2c1.4-.8 4.1-1.4 6.4-1.4 2.3 0 5 .6 6.4 1.4l.6-1.1V28h9.1V17h-9.5zM8.9 19.5h5.4v6.1H8.9v-6.1zm7.8 5.4v-4.7c1.7.6 3.8.9 5.8.9 1.7 0 3.9-.3 5.8-.9v4.7c-1.7-.6-3.8-.9-5.8-.9-1.7-.1-3.9.2-5.8.9zm19.4.6h-5.3v-6.1h5.3v6.1z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.7,
			y: 5.5,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 3.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.7,
			y: 11.1,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 3.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.7,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 3.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.8,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 3.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.8,
			y: 5.5,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 3.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.8,
			y: 11.1,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 3.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.7,
			y: 35.7,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 3.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.7,
			y: 41.2,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 3.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.7,
			y: 30.1,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 3.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.8,
			y: 30.1,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 3.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.8,
			y: 35.7,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 3.8
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.8,
			y: 41.2,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 3.8
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M5.6 32.1c-3.4-2-5.6-5.7-5.6-9.6 0-3.9 2.1-7.6 5.6-9.6L6.9 15c-2.7 1.5-4.3 4.4-4.3 7.5 0 3.1 1.7 5.9 4.3 7.5l-1.3 2.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M39.4 32.1l-1.3-2.2c2.7-1.5 4.3-4.4 4.3-7.5 0-3.1-1.7-5.9-4.3-7.5l1.3-2.2c3.4 2 5.6 5.7 5.6 9.6-.1 4.1-2.2 7.8-5.6 9.8z"
		})
	]
});
export default SvgIcon;
